import { AppBar, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	EmptyList,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../common/constants";
import { IResponse, IServerError } from "../../../models/common";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {

	formatDate,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount
} from "../../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AuthService } from "../../../services";
import { CompanyTD1FormService } from "../../../services/CompanyTD1FormService";
import { DateRange } from "@mui/icons-material";
import { EmployeeService } from "../../../services/EmployeeService";
import FileSaver from "file-saver";
import { IAppState } from "../../../store/reducers";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../../models";
import { LookupFieldService } from "../../../services/LookupFieldService";
import { PrimeDataGridWithRowExpansion } from "../../PrimeDataGridWithRowExpansion";
import { RQRamittanceService } from "../../../services/RQRamittanceService";
import { RQReportDataGridWithColumnToggled } from "./RQReportDataGridWithColumnToggled";
import { RQReportHeader } from "./RQReportHeader";
import { ReportsService } from "../../../services/ReportsService";
import { endOfDay } from "date-fns";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";

export interface IRQReportSetupPage { }
const RQ_REPORT_QUERY_KEY = "rq-report";
const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";

const useRQRamittanceSavedFrequency = (
	clientId: string,
	taxYear: number,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			'rq-remittance-saved-frequency',
		],
		queryFn: (data) => {

			return RQRamittanceService.getRQRamittanceSavedFrequency(
				clientId,
				taxYear,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetRemittanceFrequencyDDL = () =>
	useQuery({
		queryKey: ["remittance-Frequency-ddl"],
		queryFn: (data) => {
			return RQRamittanceService.getRemittanceFrequencyDDL();
		},
		refetchOnWindowFocus: false,
	});

const useRQReport = (
    remittanceFrequencyId: null | {label:string,value:string},
	viewByDate: number,
	clientId: string,
	taxYear:number,
	params: IGetListRequest,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			RQ_REPORT_QUERY_KEY,
			remittanceFrequencyId,
			viewByDate,
			clientId,
			taxYear,
			params,
		],
		queryFn: () =>
			ReportsService.getRQReport(
				remittanceFrequencyId,
				viewByDate,
				clientId,
				taxYear,
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});


export const useGetLookupFieldData = (lookupFieldId: string) =>
	useQuery({
		queryKey: [GET_QUERY_KEY.LOOKUP_FIELD_DATA_BY_ID, lookupFieldId],
		queryFn: (data) => {
			return LookupFieldService.getByIdd(lookupFieldId);
		},
		refetchOnWindowFocus: false,
	});

const useGetMaskStatus = () =>
	useQuery({
		queryKey: ["mask-status"],
		queryFn: (data) => {
			return AuthService.getMaskStatus();
		},
		refetchOnWindowFocus: false,
	});

// const useGetEmployeeDDLItems = (
// 	clientId: string,
// 	status: number,
// 	taxYear: number
// ) =>
// 	useQuery({
// 		queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, status, taxYear],
// 		queryFn: (data) => {
// 			return CompanyTD1FormService.getEmployeeDDLByStatus(clientId, status, taxYear);
// 		},
// 		refetchOnWindowFocus: false,
// 	});


export const RQReport: React.FC<IRQReportSetupPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const [RQReportData, setRQReportData] =
		useState<any>(undefined);
	const [employeeStatus, setEmployeeStatus] = useState<number>(100);
	const [viewByDate, setViewByDate] = useState<number>(200);



	const {
		isLoading: isLoadingPayFrequency,
		data: employeeReportSetupPayFrequencyList,
	} = useGetLookupFieldData("payPeriods");

	const { isPending: isPendingMaskStatus, data: maskStatus } =
		useGetMaskStatus();

	const formMethods = useForm<any>({
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	// const onImportFileClicked = useCallback(() => {
	// 	alert(`Import Icon Clicked!`);
	// }, []);

	// const onExcelToPdfClicked = useCallback(() => {
	// 	alert(`Excel Icon Clicked!`);
	// }, []);

	// const onApplyButtonClickedHandler = useCallback(() => {
	// 	const values = formMethods.getValues();

	// }, []);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	// const employeeId = formMethods.getValues("employeeDDL");
	// const status = formMethods.getValues("employeeStatus");
	// const startDate = formMethods.getValues("startDate");
	// const endDate = formMethods.getValues("endDate");
	// const dateRange = formMethods.getValues("showReport");

	// const formattedStartDate = formatDate(startDate);
	// const formattedEndDate = formatDate(endDate);

	let [companySavedRemittance, setCompanySavedRemittance] = useState<any>(null)
	const { isPending: isPendingRQRamittanceSavedFrequency, data: rqRamittanceSavedFrequency }: any = useRQRamittanceSavedFrequency(
		clientIdStore,
		taxYear,
		navigateToLogout
	);

	const {
		isPending: isPendingRemittanceFrequencyDDL,
		data: remittanceFrequencyDDL,
	} = useGetRemittanceFrequencyDDL();

	useEffect(() => {
		if (remittanceFrequencyDDL && rqRamittanceSavedFrequency && rqRamittanceSavedFrequency.frequencies !== null) {
			let currentCompanySavedRemittance = remittanceFrequencyDDL.find((item: any) => item.value === rqRamittanceSavedFrequency.frequencies);
			setCompanySavedRemittance(currentCompanySavedRemittance)
		}
	}, [rqRamittanceSavedFrequency, remittanceFrequencyDDL])



	const { isPending, data } = useRQReport(
		companySavedRemittance,
		viewByDate,
		clientId,
		taxYear,
		queryParams,
		navigateToLogout
	);
	const RQList: any | null = data;
	useEffect(() => {
		if (RQList) {
			setRQReportData(RQList);
		}
	}, [RQList]);

	

	const onSubmit = (values: any) => {
		
	};

	const [zeroEmployee, setzeroEmployee] = useState(true);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const {
		isPending: isSubmittingAddRemoveHeaderColumns,
		mutate: submitAddRemoveHeaderColumns,
	} = useMutation({
		mutationFn: ReportsService.getRQAddRemoveHeaderColumns,
		onSuccess: (res: any | IServerError | IResponse) => {
			if (res.status === 200) {
				return queryClient.invalidateQueries({
					queryKey: [RQ_REPORT_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: res.message
						? res.message
						: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err: any) => {
			setSnackbarData({
				open: true,
				message: err.message,
				severity: "error",
			});
		},
	});

	useEffect(() => {
		if (submitAddRemoveColumnsHandler) {
			submitAddRemoveHeaderColumns({
				clientId: clientId,
				columns: submitAddRemoveColumnsHandler,
				navigateToLogout: navigateToLogout,
			});
		}
	}, [submitAddRemoveColumnsHandler]);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["employee-report"]);

	const upadtedRQListItems = useMemo(() => {
		return (
			RQReportData &&
			RQReportData.items &&
			RQReportData?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [RQReportData]);

	const onEmployeeStatusSelectionChangeHandler = (event: any) => {
		formMethods.setValue('employeeDDL', "all")
		setEmployeeStatus(event.value);
		// setSelectedEmployee(null);
		// formInitialState();
		formMethods.setValue('employeeStatus', event.value)
	};

	const onViewSelectionChangeHandler = (event: any) => {
		setViewByDate(event.value)
	};

	const expandedLabels = ["Reports", "Remittance"];
	const expandedRQOrSetupItem = "RQ";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Remittance" &&
				item.label === expandedRQOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedRQOrSetupItem && "/reports/rq",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	const { watch } = formMethods;

	const values = watch([
		"employeeDDL",
	]);

	const savePdfAsFile = (xmlData: any, filename: any) => {
		const blob = new Blob([xmlData], { type: "pdf;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};

	const onExportButtonClick = async (selectedOption: string) => {
		try {
			setIsLoading(true);
			const response = await ReportsService.exportRQReport(
				selectedOption,
				clientIdStore,
				rqRamittanceSavedFrequency.frequencies,
				taxYear,
				queryParams,
			);

			if (response) {
				if (selectedOption === "PDF") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `${clientName} - RQ-Report.pdf`;
						savePdfAsFile(response, filename);
					}
				} else if (selectedOption === "XLS") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `${clientName} - RQ-Report.xlsx`;
						savePdfAsFile(response, filename);
					}
				} else {
					const fileType =
						selectedOption === "XLS"
							? "application/vnd.ms-excel"
							: "text/csv;charset=utf-8;";
					const fileExtension = selectedOption === "XLS" ? "xls" : "csv";

					const blob = new Blob([response], { type: fileType });
					FileSaver.saveAs(blob, `${clientName} - RQ-Report.${fileExtension}`);
				}
			} else {
				console.error("Error: No data received from the server");
			}
		} catch (err) {

			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}

	};
	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"RQ Report"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<RQReportHeader companySavedRemittance={companySavedRemittance}
					onViewSelectionChangeHandler={onViewSelectionChangeHandler}
					
					/>
				</form>
			</FormProvider>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isSubmittingAddRemoveHeaderColumns ||
						isPendingRemittanceFrequencyDDL ||
						isPendingRQRamittanceSavedFrequency ||
						isLoading
						// || isPendingEmployeeDDLItems
					}
					testId="rq-report"
				/>

				<RQReportDataGridWithColumnToggled
					columns={
						RQReportData?.headerColumns
							? RQReportData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
						// RQReportData?.headerColumns ?? []
					}
					completeHeaderColumnsList={
						RQReportData
							&& RQReportData
								?.totalHeaderColumns &&
							Object.keys(RQReportData.totalHeaderColumns).length !== 0 /// comment for use hardcoded data change later
							? RQReportData.totalHeaderColumns
							: {}
						// RQReportData?.headerColumns ?? []
					}
					submitAddRemoveColumnsHandler={(value: any) =>
						setSubmitAddRemoveColumnsHandler(value)
					}
					onColumnReorder={(value: any) => setOnColumnReorder(value)}
					rows={
						RQReportData && upadtedRQListItems
							? upadtedRQListItems
							: []
						// RQReportData?.items ?? []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					// onImportButtonClickedHandler={onImportFileClicked}
					// onImportExcelButtonClickedHandler={onExcelToPdfClicked}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						RQReportData && RQReportData.total
							? RQReportData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroEmployee(value)
					}
					pageTitle={"RQ Report"}
					onExportButtonClick={onExportButtonClick} 

					// {/* // ///////////////////////////// Expanded Rows ///////////////////////////////////////////// */}
					showRowExpandedView={true}
				/>

				{/* <PrimeDataGridWithRowExpansion
					columns={
						// RQReportData?.headerColumns
						// 	? RQReportData.headerColumns.filter(
						// 		(item: any) => item.field !== "id"
						// 	)
						// 	: []
						RQReportData?.headerColumns ?? []
					}
					// completeHeaderColumnsList={
					// 	// RQReportData
					// 	// 	&& RQReportData
					// 	// 		?.totalHeaderColumns &&
					// 	// 	Object.keys(RQReportData.totalHeaderColumns).length !== 0 /// comment for use hardcoded data change later
					// 	// 	? RQReportData.totalHeaderColumns
					// 	// 	: {}
					// 	RQReportData?.headerColumns ?? []
					// }
					// submitAddRemoveColumnsHandler={(value: any) =>
					// 	setSubmitAddRemoveColumnsHandler(value)
					// }
					// onColumnReorder={(value: any) => setOnColumnReorder(value)}
					rows={
						// RQReportData && upadtedRQListItems
						// 	? upadtedRQListItems
						// 	: []
						RQReportData?.items ?? []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					// onImportButtonClickedHandler={onImportFileClicked}
					// onImportExcelButtonClickedHandler={onExcelToPdfClicked}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						RQReportData && RQReportData.total
							? RQReportData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroEmployee(value)
					}
					pageTitle={""}
				// onExportButtonClick={onExportButtonClick} // change later to salaryProfile values
				/> */}

				{RQReportData ? (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							backgroundColor: "#F7F7F7",

							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					></AppBar>
				) : (
					<></>
				)}
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
